"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M4.47 20.5h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.49c-.77-1.33-2.69-1.33-3.46 0L2.74 17.5c-.77 1.33.19 3 1.73 3M12 13.5c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1m1 4h-2v-2h2z"
}), 'WarningRounded');